export default {
  newConference: 'Nouvelle téléconférence',
  dialInNumber: 'Numéro à composer',
  host: 'Animateur',
  participants: 'Participants',
  internationalParticipants: 'Participants internationaux',
  internationalNumbersHeader: 'Sélectionner les numéros internationaux à composer',
  search: 'Recherche...',
  inviteWithText: 'Inviter par texto',
  inviteText: 'Veuillez joindre la téléconférence RingCentral. \n\nNuméros à composer : {dialInNumber} \n\n{internationals} \nAccès du participant : {participantCode} \n\nBesoin d\'un numéro de téléphone international à composer ? Veuillez consulter le http://www.ringcentral.com/conferencing \n\nCette téléconférence vous est offerte par Téléconférence RingCentral.',
};
